import Sortable from 'sortablejs';

$(document).on('ready turbolinks:load', () => {
  $('[data-sortable-group-name]').each((index, elem) => {
    const $elem = $(elem);
    Sortable.create(elem, {
      group: $elem.data('sortable-group-name'),
    });
  });
});
